import { render, staticRenderFns } from "./BkashCampaign.vue?vue&type=template&id=4cb2e164&scoped=true&"
import script from "./BkashCampaign.vue?vue&type=script&lang=js&"
export * from "./BkashCampaign.vue?vue&type=script&lang=js&"
import style0 from "./BkashCampaign.vue?vue&type=style&index=0&id=4cb2e164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb2e164",
  null
  
)

export default component.exports